import { render } from "./updateOrderStatus.vue?vue&type=template&id=49d68878"
import script from "./updateOrderStatus.vue?vue&type=script&lang=js"
export * from "./updateOrderStatus.vue?vue&type=script&lang=js"
script.render = render

export default script